export const US_COUNTRY_CODE = 'US';